import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiNieuwegeinEindhovenAirportPage() {
  return (
    <CityAirportTemplate
      city="Nieuwegein"
      airport="eindhoven"
      airportName="Eindhoven Airport"
      price={85.00}
      distance="75 km"
      duration="55-60 minuten"
    />
  );
}
